import PropTypes from 'prop-types';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import { numbersSchema } from './schema';

const NumbersData = (props) => {
  const { data, block, onChangeBlock } = props;
  const schema = numbersSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

NumbersData.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default NumbersData;
